<button *ngIf="!loading" class="eb-load-more-button__button" (click)="clicked.emit()">
  {{ 'productVariantList.showMore' | cxTranslate }}
</button>
<div *ngIf="loading">
  <eb-spinner></eb-spinner>
</div>
